import { DataBean } from "../DataBean";

export class BudgetTypes extends DataBean {


    public async getBudgetTypes(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetTypes_Number", [args]);
    }

}